import { GridColDef } from '@mui/x-data-grid';

export interface ManualExperienceLocation {
  id: string;
  experienceOfferId: string;
  experienceOfferName: string;
  placeName: string;
  placeId: string;
  comments: string;
  addedBy: string;
  createdAt: string;
}

const defaultFields: Partial<GridColDef> = {
  sortable: false,
  disableColumnMenu: true,
  flex: 1,
  display: 'flex',
  type: 'singleSelect',
};

export const defaultColumns: Array<GridColDef<ManualExperienceLocation>> = [
  {
    ...defaultFields,
    field: 'experienceOfferName',
    headerName: 'Experience Offer Name',
  },
  {
    ...defaultFields,
    field: 'experienceOfferId',
    headerName: 'Experience Offer ID',
  },
  {
    ...defaultFields,
    field: 'placeName',
    headerName: 'Place Name',
  },
  {
    ...defaultFields,
    field: 'placeId',
    headerName: 'Place ID',
  },
  {
    ...defaultFields,
    field: 'comments',
    headerName: 'Comments',
  },
  {
    ...defaultFields,
    field: 'addedBy',
    headerName: 'Added By',
  },
  {
    ...defaultFields,
    field: 'createdAt',
    headerName: 'Created At',
  },
];
